import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '~/store/apis/baseQuery/baseQuery';

export const myPagesUnauthenticatedBaseApi = createApi({
  reducerPath: 'myPagesUnauthenticatedBaseApi',
  endpoints: () => ({}),
  baseQuery: baseQuery(import.meta.env.VITE_API_MYPAGES_URL, false),
});
